import {eventBus, EVENTS} from "./EventBus.js";
import './videojs.rds.adv.js';
import '../libs/video.js';

const PLAYER_IMA_EVENTS = {
  IMA_LOADED: 'ima_ad_loaded',
  IMA_START: 'ima_ad_started',
  IMA_SKIPPED: 'ima_ad_skipped',
  IMA_END: 'ima_ad_complete',
  IMA_ERROR: 'ima_ad_error'
};
const INTERNAL_PLAYER_IMA_EVENTS = {
  AD_STARTED: 'ads-ad-started',
  AD_MANAGER: 'ads-manager',
  AD_LOADER: 'ads-loader',
  AD_REQUEST: 'ads-request'
};
const PLAYER_EVENTS = {
  READY: 'ready',
  RESUME: 'resume',
  PLAY: 'play',
  PAUSE: 'pause',
  STOP: 'stop',
  UNLOAD: 'unload',
  FINISH: 'finish',
  PROGRESS: 'progress',
  METADATA: 'metadata',
  LOADED_METADATA:'loadedmetadata',
  TIMEUPDATE: 'timeupdate',
  ENDED: 'ended',
  TRACK_PLAY: 'trackplay',
  TRACK_STOP: 'trackstop',
};
const tamponi={
  rds:'https://media.rds.it/web/web-site-brandnew/tampone_socialtv.png',
  serieA:'https://media.rds.it/web/web-site-brandnew/tamponeaperrds.png?i=0',
}
const DEBUG = false;

let totalDurationSpotSec=0;

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function parseLiveMetadata(value, player) {
  let meta;
  const cues = player.textTracks()[0].activeCues;
  let metaj;
  try {
    const n = value.data.search("TIT2");
    meta = (value.data.substring(n + 11));
  } catch (e) {
    for (let i = 0; i < cues.length; i++) {
      const cueVal = cues[i].value;
      if (cueVal && cueVal.key && cueVal.key == "TIT2") {
        meta = cueVal.data;
      }
    }
  }
  const res = meta.split(" * ");
  let type = res[0].toUpperCase();
  if (type == 'SPOT') {
    return {
      type: 'spot'
    }
  } else if (type == 'LINK') {
    return {
      type: 'link'
    }
  }
  try {
    let j = value.data.search("JSI3");
    metaj = (value.data.substring(j));
  } catch (e) {
    for (let i = 0; i < cues.length; i++) {
      let cueVal = cues[i].value;
      if (cueVal && cueVal.key && cueVal.key == "JSI3") {
        metaj = cueVal.data;
      }
    }
    try {
      var enc = new TextDecoder("utf-8");
      metaj = enc.decode(metaj);
    } catch (e) {
      // console.log('Ti meriti che non compaia');
    }
  }
  if (!metaj) {
    return {
      type: 'song'
    };
  }
  // console.log('rdsplayer', metaj);
  const metajson = metaj.substring(metaj.lastIndexOf("{"), metaj.lastIndexOf("}") + 1);
  try {
    let songObj = JSON.parse(metajson);
    if (songObj.type == 'song') {
      let song = {
        traccia: songObj.traccia,
        id: songObj.id,
        artista: songObj.artista,
        idMasterControl: songObj.id_master_control,
        feat: songObj.feat,
        remix: songObj.remix,
        likes: songObj.likes,
        dedications: songObj.dedications,
        snippet: songObj.snippet,
        type: songObj.type
      }
      return {
        type: 'song',
        song: song
      };
    }
  } catch (error) {
    return {
      type: 'song'
    };
  }



}

export default class RDSPlayer {

  get container() {
    return document.querySelector(this.selector).firstElementChild;
  }
  get id(){
    return this.container.id;
  }
  constructor({ container, sources, ima, isLive }) {
    this.subscribers = {};
    this.player = false;
    this.hasPreroll = false;
    this.selector = container;
    this.waitPreroll=true;
    this.counter=0;
    this.player = videojs(container, {
      sources: sources,
      autoplay: false,
      metadata: true,
      preload: 'metadata',
      html5: {
        vhs: {
          overrideNative: true
        },
        nativeAudioTracks: false,
        nativeVideoTracks: false
      }
    }, function (a, b, c) {
      // console.log(a, b, c);
      this.container = document.querySelector(container);
    });
    this.isLive = isLive
    //Hide video preroll;
    //ima = false;
    if (ima) {

      const adCont=document.getElementById('rds-ad-container');
      this.ima=ima;
      this.adCont=adCont;

      // let imaOptions = {
      //   adTagUrl: ima,
      //   adsManagerLoadedCallback: this.adsManagerLoadedCallback.bind(this)
      // };

      // this.player.ima(imaOptions);
      // this.hasPreroll = true;
      this.on('pause',()=>{
        if(!this.waitPreroll){
          this.triggerEvent(PLAYER_EVENTS.TRACK_STOP);
        }
      });
      if(this.isLive){
        this.player.one('play', () => {
          requestAdRun(this.ima, this.container, adCont, this, true);
          this.player.on('play', () => {
            if(!this.waitPreroll){
              this.waitPreroll=true;
              requestAdRun(this.ima, this.container, adCont, this, true);
            }else{
              this.triggerEvent(PLAYER_EVENTS.TRACK_PLAY);
            }
          });
          // this.player.ima.initializeAdDisplayContainer();
          // this.player.ima.requestAds();
        });
      }else{
        this.waitPreroll=false;
        this.player.on('play', ()=>{
          if(!this.waitPreroll){
            this.waitPreroll=true;
            requestAdRun(this.ima, this.container, adCont, this);
          }else{
            this.triggerEvent(PLAYER_EVENTS.TRACK_PLAY);
          }
        });
      }

      this.player.on('IMA_END',()=>{
        setTimeout(()=>{
          this.waitPreroll=false;
        },500);

      })

      this.on('IMA_START', (e)=>{
        if(!e.isVideo){
          showTampone(this.container);
        }
        showCountdown(this,this.container);
        console.log(e)
      });
      this.player.on('IMA_END', (e)=>{
        hideTampone(this.container);
        console.log(e)
      });

    }else{
      this.waitPreroll=false;
    }
    // this.player = flowplayer(container, config);
    this.initListeners();

    this.playing = () => { return !this.player.paused() };
  }
  restartPreroll(){
      if(this.ima){
        this.stop();
        this.waitPreroll=true;
        requestAdRun(this.ima, this.container, this.adCont, this);
      }
    }


  play() {
    if(this.hasPreroll && this.waitPreroll && !this.isLive){
      return;
    }
    if (DEBUG) {
      console.log('play');
    }
    this.player.play();

  }
  stop() {
    if (DEBUG) {
      console.log('stop');
    }
    this.player.pause();
    this.currentTime(0);
  }
  pause() {
    if (DEBUG) {
      console.log('pause');
    }
    this.player.pause();
  }

  on(eventName, fn) {
    const id = uuidv4();
    if (eventName == 'resume') {
      eventName = 'play';
    }
    if (!this.subscribers[eventName]) {
      this.subscribers[eventName] = [];
    }
    this.subscribers[eventName].push({ id: id, fn: fn });
    return id;
  }
  off(id) {
    for (const eventName in this.subscribers) {
      const idx = this.subscribers[eventName].findIndex((s) => s.id === id);
      if (idx != -1) {
        this.subscribers[eventName].splice(idx, 1);
      }
    }
  }

  triggerEvent(eventName, data) {
    if (DEBUG && eventName!='timeupdate'&& eventName!='progress') {
      console.log('triggerEvent', eventName);
    }
    if (!this.subscribers[eventName]) {
      return
    }
    for (let i = 0; i < this.subscribers[eventName].length; i++) {
      if (DEBUG && eventName!='timeupdate'&& eventName!='progress') {
        console.log('triggerEvent to subscriber', eventName);
      }

      const objFn = this.subscribers[eventName][i];
      const fn = objFn.fn;
      fn.apply(this, [data]);
    }
  }
  getSource() {
    return this.player.src();
  }
  setSource(source) {
    // this.player.stop();
    // this.player.unload();
    // this.player.load(source);

    let type = "audio/mp3";
    const suffix = source.split('.').reverse()[0];
    if (suffix == 'm3u8') {
      type = "application/x-mpegurl";
    }
    this.setSources([{ type: type, src: source }]);
    // this.player.src({ type: type, src: source });
  }
  setSources(sources) {
    if(this.playing() && !this.waitPreroll){
      // console.log('****************** Questo è lo stop da tracciare');
      this.triggerEvent(PLAYER_EVENTS.TRACK_STOP);
    }
    
    this.triggerEvent('sourcechange', { oldSource: this.getSource(), newSource: sources[0].src });
    this.player.src(sources);
  }

  get duration() {
    return this.player.duration();
  }

  getDuration() {
    return this.player.duration();
  }
  currentTime(t) {
    return this.player.currentTime(t);
  }

  adsManagerLoadedCallback() {
    const IMA_EVENTS_MAP = {
      [google.ima.AdEvent.Type.STARTED]: PLAYER_IMA_EVENTS.IMA_START,
      [google.ima.AdEvent.Type.ALL_ADS_COMPLETED]: PLAYER_IMA_EVENTS.IMA_END,
      [google.ima.AdEvent.Type.COMPLETE]: PLAYER_IMA_EVENTS.IMA_END,
      [google.ima.AdEvent.Type.SKIPPED]: PLAYER_IMA_EVENTS.IMA_SKIPPED,
      [google.ima.AdEvent.Type.LOADED]: PLAYER_IMA_EVENTS.IMA_LOADED,
      [google.ima.AdEvent.Type.PAUSED]: PLAYER_IMA_EVENTS.IMA_PAUSED,
      [google.ima.AdEvent.Type.RESUMED]: PLAYER_IMA_EVENTS.IMA_RESUMED,
    };
    for (const key in IMA_EVENTS_MAP) {
      if (Object.hasOwnProperty.call(IMA_EVENTS_MAP, key)) {
        const value = IMA_EVENTS_MAP[key];
        this.player.ima.addEventListener(key, (e) => { this.triggerEvent(value, e); });
      }
    }
    this.player.on('adslog', (data) => { this.triggerEvent(PLAYER_IMA_EVENTS.IMA_ERROR, data.data.AdError); });
  }

  initListeners() {
    let customEvents = [];
    if (this.isLive) {
      customEvents = [PLAYER_EVENTS.METADATA];
      this.player.on(PLAYER_EVENTS.METADATA, (e, value) => {
        const eventParams = parseLiveMetadata(value, this.player);
        this.triggerEvent(PLAYER_EVENTS.METADATA, eventParams);
      });
    }

    for (const key in PLAYER_EVENTS) {
      const eventName = PLAYER_EVENTS[key];
      if (customEvents.indexOf(eventName) !== -1) {
        continue;
      }
      this.player.on(eventName, (a, b, c, d, e, f) => {
        this.triggerEvent(eventName, a, b, c, d, e, f);
      });
    }

    /* ADV*/
    if (this.hasPreroll) {
      this.on(PLAYER_IMA_EVENTS.IMA_END, (e) => {
        /*
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        const audioCtx = new AudioContext();

        */
        this.player.play();
      });
      this.player.on(INTERNAL_PLAYER_IMA_EVENTS.AD_STARTED, (e) => { console.log(e); });
      this.player.on(INTERNAL_PLAYER_IMA_EVENTS.AD_MANAGER, (e) => { console.log(e); });
      this.player.on(INTERNAL_PLAYER_IMA_EVENTS.AD_LOADER, (e) => {
        console.log(e);
        e.adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e) => { console.log(e) }, false);
      });
      this.player.on(INTERNAL_PLAYER_IMA_EVENTS.AD_REQUEST, (e) => { console.log(e); });
    }

    this.on(PLAYER_EVENTS.PLAY, () => {
      eventBus.emit(EVENTS.STOP_ALL_PLAYER, this);
    });

    eventBus.on("STOP_ALL_PLAYER",(context)=>{

      if(context.container == this.container)
        return

      this.pause();

    });

    this.player.on("click", function(event){
      event.preventDefault();
    });

  }

}

function showTampone(container){
  const tampone=document.createElement('img');
  let img=tamponi.rds;
  if(window.radioId==13){
    img=tamponi.serieA;

  }
  tampone.src=img;
  tampone.id='tampone-videopreroll';
  container.parentElement.append(tampone);
  // container.parentElement.append(countdown);
}

function showCountdown(player,container){
  const countdown = document.createElement('div');
  countdown.innerHTML = `Il tuo contenuto sarà disponibile tra <span id="duration"></span> secondi`;
  countdown.id='countdown';
  console.log('newAdUnit',player.newAdUnit);
  if (player.newAdUnit){
    let duration = 0;
    const adElements = player.newAdUnit.vastChain[0].ad.elements;
    try {
      duration = adElements.find((element) => element.name == 'inline').elements
        .find((element) => element.name == 'creatives').elements
        .find((element) => element.name == 'creative').elements
        .find((element) => element.name == 'linear').elements
        .find((element) => element.name == 'duration').elements
        .find((element) => element.type == 'text')
        .text;
    }catch (e) {
      try {
        duration = Math.floor(player.newAdUnit.videoAdContainer.videoElement.duration);
      }catch (e) {
        console.warn('Durata spot non trovata');
      }
    }
    if (typeof duration === "number"){
      return;
    }
    const durationSec = parseInt(duration.split(':')[2]);
    const durationMin = parseInt(duration.split(':')[1])*60;
    totalDurationSpotSec = durationMin+durationSec-1;
    console.log('totalDurationSpotSec',totalDurationSpotSec);
    container.parentElement.append(countdown);
    document.getElementById('duration').innerText = totalDurationSpotSec;
    let durationInterval = setInterval(() => {
      if (totalDurationSpotSec > 0){
        try {
          document.getElementById('duration').innerText = totalDurationSpotSec;
          totalDurationSpotSec--;
        } catch (error) {
          clearInterval(durationInterval);
          console.warn(error);
        }
      }else{
        clearInterval(durationInterval);
      }
    },1000);
  }
}

function hideTampone(){
  const tampone=document.getElementById('tampone-videopreroll');
  const countdown=document.getElementById('countdown');
  if(tampone){
    document.getElementById('tampone-videopreroll').remove();
  }
  if (countdown){
    countdown.remove();
  }
}
